module.exports = __webpack_public_path__ + "img/Altruvest Full Logo - White Text.c16f29c2.svg";